/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({ datasetIdentifier: z.string() });

export const WebhookClusterGwDatasetPut = {
  id: 'webhook.cluster-gw.dataset.put',
  tag: 'Webhook',
  summary: 'Update ClusterGW dataset via Webhook',
  description: 'Update ClusterGW dataset via Webhook',
  method: 'put',
  route: (params: z.infer<typeof Params>) => `/webhook/clustergw/dataset/${params.datasetIdentifier}`,
  request: {
    params: Params,
    body: {
      content: {
        'application/json': {
          schema: z.strictObject({
            category: z.string().min(1),
            name: ZodTypes.TrimmedString.min(1),
            description: ZodTypes.TrimmedString.min(1),
            database: ZodTypes.TrimmedString.min(1),
            schema: ZodTypes.TrimmedString.min(1),
            rawSizeMb: z.number().min(1),
            finalSizeMb: z.number().min(1),
            importSizeMb: z.number().min(1),
            extensions: z.string().array().min(1).optional(),
          }),
        },
      },
    },
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.string().optional(),
        },
      },
    },
  },
} as const satisfies Endpoint;
